const Case = ()=>{
    return (<div className="flex flex-col  mx-auto p-10 gap-y-5  lg:w-2/3 border-2 shadow-md text-md md:text-xl" >

<p className="text-md md:text-xl font-semibold font-mono text-black-400">Case study</p>  
           
           <div className="flex flex-col p-5 border-t-4 gap-y-2">

               
               <p>One whould expect that common to many cultures name Marianne would not be a difficult to pronounce.
               But here we can see that this is not exactly the case!</p>
                <p>Here it is pronounced by Norwegian native speaker (the Norwegian writer Erlend Loe) </p>
           
           <audio preload="auto"  controls  
                   className='mx-auto scale-75 sm:scale-95 md:scale-100 2xl:scale-110 my-5 '  src="https://www.catchphraser.com/api/uploads/screens/marianna_erlend_mono.wav" 
                   type="wav/audio"/>


        <p>Dmitry is reading the same word on 2025.02.20 and getting a confusing score 0 by the Microsoft Pronunciation Assessment tool:
        </p>

        <audio preload="auto"  controls  
                   className='mx-auto scale-75 sm:scale-95 md:scale-100 2xl:scale-110 my-5 '  
                   src="https://www.catchphraser.com/api/uploads/screens/marianna_0.wav" 
                   type="wav/audio"/>

<p>Dmitry is reading the same word on 2025.04.26 and getting a score 100 by the Microsoft Pronunciation Assessment tool:
        </p>

        <audio preload="auto"  controls  
                   className='mx-auto scale-75 sm:scale-95 md:scale-100 2xl:scale-110 my-5 '  
                   src="https://www.catchphraser.com/api/uploads/screens/marianna_100.wav" 
                   type="wav/audio"/>


            <p>Here is a Praat visualization of all three recording</p>

            <img alt="Praat" className="object-contain md:object-cover mx-auto p-5" 
                   src={`${process.env.REACT_APP_USER_API_URL}/`+"uploads/screens/praat.png"} />
          
</div>

    </div>)
}
export default Case;